import { render, staticRenderFns } from "./products.vue?vue&type=template&id=ac2789fa&scoped=true&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "./products.vue?vue&type=style&index=0&id=ac2789fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2789fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac2789fa')) {
      api.createRecord('ac2789fa', component.options)
    } else {
      api.reload('ac2789fa', component.options)
    }
    module.hot.accept("./products.vue?vue&type=template&id=ac2789fa&scoped=true&", function () {
      api.rerender('ac2789fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/allProducts/products.vue"
export default component.exports